import React from "react";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#111110] text-[#F4F4EB] py-24 md:py-32 border-b border-[#333333] grain"
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-7">
          <div className="uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-4">
            About The Owner
          </div>
          <h2
            data-testid="about-heading"
            className="font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[0.95]"
          >
            Hi, I&apos;m Michael Schaefer.
            <br />
            <span className="text-[#E5231A]">I Run Every Job Myself.</span>
          </h2>
          <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-[#F4F4EB]/75 max-w-2xl">
            <p>
              I started Schaefer Services to do contracting the way it used
              to be done — one honest handshake at a time. No sub-contracted
              shortcuts, no ghosting after the deposit clears. When I take on a
              project, I&apos;m the one on-site running the equipment, setting
              the grade, and making sure it&apos;s done the way I&apos;d want
              it on my own property.
            </p>
            <p>
              We serve Abilene and the surrounding West Texas communities with
              a full lineup of dirt work, fence work, tree service, outdoor
              construction, and heavy equipment repair. If it&apos;s outside
              and it needs doing — we&apos;ve probably already done it.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#contact"
              data-testid="about-cta-quote"
              className="btn-hard-invert inline-flex items-center gap-2 bg-[#E5231A] text-[#F4F4EB] font-bold uppercase text-sm tracking-wider px-6 py-3 border border-[#F4F4EB]"
            >
              Start a Project
            </a>
            <a
              href="tel:+13255133501"
              data-testid="about-cta-call"
              className="inline-flex items-center gap-2 bg-transparent text-[#F4F4EB] font-bold uppercase text-sm tracking-wider px-6 py-3 border border-[#F4F4EB] hover:bg-[#F4F4EB] hover:text-[#111110] transition-colors"
            >
              <Phone size={16} weight="fill" /> Call Michael
            </a>
          </div>
        </div>

        <aside className="lg:col-span-5">
          <div className="border border-[#333333] bg-[#1b1b1a]">
            <div className="p-6 md:p-8 border-b border-[#333333]">
              <div className="uppercase text-xs tracking-[0.3em] font-bold text-[#E5231A]">
                Direct Line
              </div>
              <div className="mt-2 font-display font-black text-3xl md:text-4xl tracking-tight">
                The Boss Answers.
              </div>
            </div>

            <ul className="divide-y divide-[#333333]">
              <li className="p-6 md:p-8 flex items-start gap-4">
                <Phone size={22} weight="fill" className="text-[#E5231A] mt-1" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#F4F4EB]/60">Phone</div>
                  <a
                    href="tel:+13255133501"
                    data-testid="about-phone"
                    className="block font-display font-extrabold text-xl md:text-2xl hover:text-[#E5231A] transition-colors"
                  >
                    (325) 513-3501
                  </a>
                </div>
              </li>
              <li className="p-6 md:p-8 flex items-start gap-4">
                <EnvelopeSimple size={22} weight="fill" className="text-[#E5231A] mt-1" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#F4F4EB]/60">Email</div>
                  <a
                    href="mailto:m.schaefer@schaeferservicestx.com"
                    data-testid="about-email"
                    className="block font-display font-extrabold text-lg md:text-xl break-all hover:text-[#E5231A] transition-colors"
                  >
                    m.schaefer@schaeferservicestx.com
                  </a>
                </div>
              </li>
              <li className="p-6 md:p-8 flex items-start gap-4">
                <MapPin size={22} weight="fill" className="text-[#E5231A] mt-1" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#F4F4EB]/60">Service Area</div>
                  <div className="font-display font-extrabold text-lg md:text-xl">
                    Abilene, TX &amp; Surrounding
                  </div>
                </div>
              </li>
              <li className="p-6 md:p-8 flex items-start gap-4">
                <Clock size={22} weight="fill" className="text-[#E5231A] mt-1" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#F4F4EB]/60">Hours</div>
                  <div className="font-display font-extrabold text-lg md:text-xl">
                    Mon – Sat · 7a – 7p
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}
